import Coverage from 'pages/benefits/coverage/Coverage';
import { CoveragePlan } from 'all-in-one-shared-api';

function SupplementaryMajorMedical() {
  return <Coverage coveragePlan={CoveragePlan.SUPP_MAJOR_MEDICAL} />;
}

export default SupplementaryMajorMedical;
